import {useEffect, useState} from 'react';
import {useQueryClient} from 'react-query';
import CreateNewRequest from '../../../../createNewRequest/createNewRequest';
import LoanTemplateDetail from './LoanTemplateDetail';
import LoanTemplateList from './LoanTemplateList';
import LayoutWithoutDrawer from '../../../../../layouts/LayoutWithoutDrawer';
import BasicInforContainer from '../../../../basicInformation/basicInfoContainer';
import {useLocation, useNavigate} from 'react-router-dom';

const LoanTemplateContainer = ({
    setStep,
    setTabChild,
}: {
    setStep: any;
    setTabChild: any;
}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [key, setKey] = useState<string>('');
    const queryClient = useQueryClient();
    const setInnerState = (state: string) => navigate(`/loans/request/${state === 'selectLoanTemplate' ? '' : state}`);
    if (location.pathname.endsWith('/confirmLoanTemplate')) return <LoanTemplateDetail
                setInnerState={setInnerState}
                setTabChild={setTabChild}
                loanTemplateKey={
                    key ? key : queryClient.getQueryData('LOAN_TEMPLATE_KEY')!
                }
            />;
    if (location.pathname.endsWith('/createNewRequest')) return <CreateNewRequest
                setInnerState={setInnerState}
                setStep={setStep}
                loanTemplateKey={
                    key ? key : queryClient.getQueryData('LOAN_TEMPLATE_KEY')
                }
            />;
    if (location.pathname.endsWith('/TemporaryRegistered')) return <LayoutWithoutDrawer>
                <BasicInforContainer
                    referenceKey={undefined!}
                    setStep={setStep}
                    back="calculator"
                />
            </LayoutWithoutDrawer>;
    return <LoanTemplateList setInnerState={setInnerState} setKey={setKey} />;
};

export default LoanTemplateContainer;
